<template>
	<resource-list-item :image="!rating.user ? DefaultUser.avatar_thumbnail : rating.user.avatar_thumbnail"
						:title="!rating.user ? $t('label.anonymous_rating') : rating.user.display_name"
						:subtitle="rating.participation_class_name"
						:description="rating.description"
						:divided="props.divided"
						:value="`rating-${rating.id}`"
						focused-description>

		<template v-if="props.editable" #right>
			<tooltip v-if="rating.private" left with-touch :text="$t('text.event.ratings.private')">
				<icon xx-small color="gray-300" class="mr-8" :icon="icons.anonymous"/>
			</tooltip>
			<tooltip bottom :text="$t('action.edit')">
				<btn @click="edit" small icon>
					<icon :icon="icons.edit"/>
				</btn>
			</tooltip>
		</template>

		<form-rating v-model.number="rating.rating" readonly small left/>

		<div class="flex justify-between items-center">
			<dynamic-date x-small class="text-subtext-color" right :date="rating.created_at"/>

			<tooltip bottom :text="$t('label.comments')">
				<btn @click="$emit('show-comments')" text large>
					<icon small force-size :icon="icons.comment"/>
					<span>{{ props.rating.comments_count }}</span>
				</btn>
			</tooltip>
		</div>
	</resource-list-item>
</template>

<script setup lang="ts">
import {EventAttendanceMode, EventPreview, EventRating} from "@spoferan/spoferan-ts-core";
import {DefaultUser} from "@spoferan/spoferan-ts-core";
import {anonymousIcon, editIcon} from "@spoferan/nuxt-spoferan/icons";
import {mdiCommentMultiple} from "@mdi/js";
import {useGoogleSchema} from "../../../composables/useGoogleSchema";

const {$web, $image} = useNuxtApp();
const {t} = useI18n();

const props = withDefaults(defineProps<{
	rating: EventRating,
	divided?: boolean,
	editable?: boolean,
}>(), {});

const emit = defineEmits(['edit', 'show-comments']);

const {getEventSchemaId} = useGoogleSchema();

const icons = {
	anonymous: anonymousIcon,
	edit: editIcon,
	comment: mdiCommentMultiple
}

function edit() {
	emit('edit');
}

useSchemaOrg({
	"@type": "Review",
	"itemReviewed": {
		"@type": "SportsEvent",
		'@id': getEventSchemaId(),
	},
	"reviewRating": {
		"@type": "Rating",
		"ratingValue": props.rating.rating
	},
	"author": {
		"@type": "Person",
		"name": props.rating.user && !props.rating.private ? props.rating.user.display_name : t('label.anonymous')
	},
	"reviewBody": props.rating.description
})

</script>